/**
 * Bulk sample technique filtering utilities
 *
 * LEGACY: Used for dynamic lookup population in recipes
 * Should be removed once recipes migrate to predefined dropdown values
 */

export enum BulkSamplePrepTechnique {
  CVT = 'CVT',
  Compounding = 'CMP',
  FloatingZone = 'Floating Zone',
  HFlux = 'H Flux',
}

function IsTechniqueType(technique: string | { id: string }, type: string): boolean {
  if (typeof technique === 'string') {
    return technique.startsWith(type);
  } else if (!technique) {
    return false;
  }
  return technique.id.startsWith(type);
}

export function IsCVT(technique: string | { id: string }): boolean {
  return IsTechniqueType(technique, BulkSamplePrepTechnique.CVT);
}

export function IsCompounding(technique: string | { id: string }): boolean {
  return IsTechniqueType(technique, BulkSamplePrepTechnique.Compounding);
}

export function IsFloatingZone(technique: string | { id: string }): boolean {
  return IsTechniqueType(technique, BulkSamplePrepTechnique.FloatingZone);
}
